import IdView from "@components/idView";
import CloseIcon from "@components/alert/Icons/CloseIcon.jsx";
import React, { memo, useCallback, useState } from "react";
import PropTypes from "prop-types";
import { BettoPrimaryButton } from "../BettoButton";
import {
	CloseButton,
	CodeInput,
	ModalActions,
	ModalInfo,
	ModalOverlay,
	ModalPanel,
	ModalTitle,
	QrWrapper,
} from "./elements";

export const BettoMfaModal = memo(({ translate, data, isOpen, onClose, onVerify }) => {
	const [code, setCode] = useState("");

	const handleSubmit = useCallback(
		(event) => {
			event.preventDefault();
			if (!code.trim()) return;
			onVerify({ code }, onClose);
		},
		[code, onClose, onVerify]
	);

	if (!isOpen) return null;

	return (
		<ModalOverlay onClick={onClose}>
			<ModalPanel onClick={(event) => event.stopPropagation()}>
				<ModalTitle>{translate("ENABLE_2FA")}</ModalTitle>
				<ModalInfo>{translate("TWO_FACTOR_AUTH_INFO_P")}</ModalInfo>
				{data?.qrcode ? (
					<QrWrapper>
						<img src={data.qrcode} alt="" />
					</QrWrapper>
				) : data?.secretCode ? (
					<IdView id={data.secretCode} />
				) : null}
				<form onSubmit={handleSubmit}>
					<CodeInput
						value={code}
						placeholder={translate("VERIFICATION_CODE")}
						onChange={(event) => setCode(event.target.value)}
					/>
					<ModalActions>
						<BettoPrimaryButton type="submit" fullWidth>
							{translate("VERIFY_CODE")}
						</BettoPrimaryButton>
					</ModalActions>
				</form>
				<CloseButton type="button" onClick={onClose} aria-label="Close">
					<CloseIcon />
				</CloseButton>
			</ModalPanel>
		</ModalOverlay>
	);
});

BettoMfaModal.displayName = "BettoMfaModal";

BettoMfaModal.propTypes = {
	translate: PropTypes.func.isRequired,
	data: PropTypes.object,
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	onVerify: PropTypes.func,
};
